export const getAll = (state) => {
  return state.multiSelect;
}

export const getMode = (state) => {
  return state.multiSelect.mode;
}

export const getSelectedJurorIds = (state) => {
  return state.multiSelect.selectedJurorIds;
}

export const getJurorNames = (state) => {
  let jurorIds = getSelectedJurorIds(state);
  const jurors = state.app.jurors || {};

  let names = [];
  for (let jurorId of jurorIds) {
    if (jurors[jurorId]) {
      names.push(jurors[jurorId].nameAndId || jurorId);
    }
  }
  return names;
}

// Memoized version that avoids returning new array references on each call
import { createSelector } from '@reduxjs/toolkit';
export const getJurorNamesMemoized = createSelector(
  [getSelectedJurorIds, (state) => state.app.jurors || {}],
  (jurorIds, jurors) => {
    return jurorIds.map(id => jurors[id]?.nameAndId || id).filter(Boolean);
  }
);
